// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","listItem":"faq_listItem__9IeHZ","question":"faq_question__WYF5E"};